import { render } from "./FiveZeroZeroComponent.vue?vue&type=template&id=0936c895"
import script from "./FiveZeroZeroComponent.vue?vue&type=script&lang=js"
export * from "./FiveZeroZeroComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__